export default __webpack_public_path__ + "static/media/rampage.afcdbb44.png";